import React from 'react';
import PropTypes from 'prop-types';

const Link = (props) => (
  <span>
    Additional information about {props.tradeName} is contained in its Form ADV
    Part 2A available <a href={props.advLink}>here</a>.
  </span>
);

Link.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types -- directive added automatically by Shepherd migration
  secName: PropTypes.string,
  tradeName: PropTypes.string,
  advLink: PropTypes.string,
};

const Disclaimer = (props) => (
  <div className="disclaimer">
    You are being referred to{' '}
    {/* eslint-disable-next-line react/no-unescaped-entities -- directive added automatically by Shepherd migration */}
    {props.secName}’s website ("{props.tradeName}") by NerdWallet, Inc., a
    solicitor of{' '}
    {/* eslint-disable-next-line react/no-unescaped-entities -- directive added automatically by Shepherd migration */}
    {props.tradeName} ("Solicitor"). The Solicitor that is directing you to this
    webpage will receive compensation from {props.tradeName} if you enter into
    an advisory relationship or into a paying subscription for advisory
    services. Compensation to the Solicitor may be up to $1,500. You will not be
    charged any fee or incur any additional costs for being referred to{' '}
    {props.tradeName} by the Solicitor. The Solicitor may promote and/or may
    advertise {props.tradeName}’s investment adviser services and may offer
    independent analysis and reviews of {props.tradeName}’s services.{' '}
    {props.tradeName} and the Solicitor are not under common ownership or
    otherwise related entities.{' '}
    {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- directive added automatically by Shepherd migration */}
    {props.advLink && <Link {...props} />}
  </div>
);

Disclaimer.propTypes = {
  secName: PropTypes.string,
  tradeName: PropTypes.string,
  advLink: PropTypes.string,
};

export default Disclaimer;
